import { render, staticRenderFns } from "./EditarRecibo.vue?vue&type=template&id=5ecf8ceb&"
import script from "./EditarRecibo.vue?vue&type=script&lang=js&"
export * from "./EditarRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports